export default __webpack_public_path__ + "static/media/Minnie_May.ee88bed0.png";